import { createSlice } from "@reduxjs/toolkit";

export const resourcesSlice = createSlice({
    name: 'resources',
    initialState: [],
    reducers: {
        empty: state => {
            return []
        },
        setResources: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
        },
        add: (state, action) => {
            // return [...state, ...action.payload]
            return []
        },
        update: (state, action) => {
            // const foundedIndex = state.findIndex((unit) => unit.id === action.payload?.id);
            // if (foundedIndex !== -1) {
            //     state[foundedIndex] = action.payload
            // }
            // return state
            return []
        },
        remove: (state, action) => {
            const foundedIndex = state.findIndex((unit) => unit.id === action.payload?.id);
            if (foundedIndex) {
                return state.splice(foundedIndex, 1)
            }
            return state
        }
    }
});

export const {
    setResources, 
    empty,
    update,
    remove,
    add
} = resourcesSlice.actions;

export default resourcesSlice.reducer